// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { FeeType } from './fee-type';
import { Order } from './order';
import { PackingSlip } from './packing-slip';
import { PaymentLine } from './payment-line';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceFee extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amount!: number;
  created?: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  feeTypeId!: number;
  invoiceId?: number;
  salesOrderId?: number;
  feeType!: FeeType;
  invoice!: PackingSlip;
  paymentLines!: PaymentLine[];
  salesOrder!: Order;
}

